import type { CampaignPeriodStatus } from '@/components/Functional/utils/campaignPeriod'
import { Image } from '@/components/UI'
import { HtmlContent } from '@/components/UI/HtmlContent'
import type { CampaignData } from '@/schemas/v2/campaign'

type OutOfTermPageProps = {
  periodStatus: Exclude<CampaignPeriodStatus, 'active'>
  campaignData: CampaignData | null
}

/**
 * キャンペーン期間外（開始前 / 終了後）に表示するページコンポーネント。
 *
 * - 期間前（before）: campaignData.beforeTermMessageHtml を表示
 * - 期間後（after）:  campaignData.outOfTermMessageHtml を表示
 * - 各HTMLが未設定の場合はメッセージを表示しない（キャンペーントップ画像のみ表示）
 * - Header / BottomNavigation は表示しない
 */
export function OutOfTermPage({ periodStatus, campaignData }: OutOfTermPageProps) {
  const messageHtml =
    periodStatus === 'before'
      ? (campaignData?.beforeTermMessageHtml ?? null)
      : (campaignData?.outOfTermMessageHtml ?? null)
  const campaignImage = campaignData?.image ?? null

  return (
    <main>
      {campaignImage && <Image src={campaignImage} fit="width-fit" />}
      {messageHtml && (
        <div className="mx-4 mt-6">
          <HtmlContent html={messageHtml} variant="body1" />
        </div>
      )}
    </main>
  )
}
